<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>皮肤配置</span>
        </div>

        <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick">
          <el-tab-pane v-for="(dict,index) in types" :key="index" :name="dict.value" :label="dict.label">
            <el-table v-loading="loading" :data="tableData" border stripe>
              <el-table-column prop="start" label="类型">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.type" placeholder="请选择">
                    <el-option
                      v-for="item in types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="start" label="皮肤名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" />
                </template>
              </el-table-column>

              <el-table-column prop="start" label="文件夹名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.value" />
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-permisaction="['config:actSkin:del']" type="danger" @click="del(scope.row.id,scope.row.value, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-button v-permisaction="['config:actSkin:add']" style="margin-top: 10px" type="primary" @click="add">+</el-button>
            <el-button v-permisaction="['config:robot:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card></template>
  </BasicLayout>
</template>

<script>
import { getActivtyTypesList } from '@/api/config/activity-cfg'
import { delActiveSkin, getActiveSkinList, updateActiveSkinCfg } from '@/api/config/active-skin-cfg'

export default {
  name: 'ActSkin',
  data() {
    return {
      activeName: 'architecture',
      tabPosition: 'left',
      total: 0,
      types: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: ''
      }
    }
  },
  created() {
    this.getActivtyTypes()
  },
  methods: {
    handleClick(tab, event) {
      this.tableData = []
      this.queryParams.type = tab.name
      setTimeout(() => {
        this.getTables()
      }, 450)
    },
    handleClose(d) {
      this.drawer = false
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      this.getTables()
    },
    getActivtyTypes() {
      getActivtyTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }

          if (this.types.length > 0) {
            this.queryParams.type = this.types[0].value
            this.activeName = this.queryParams.type
          }
          this.getTables()
          // this.types.push({ label: '规则礼包', value: '9001' })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.tableData.push({ id: 0, type: this.queryParams.type, name: '', value: '' })
    },
    del(id, skin, idx) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActiveSkin({ id: id, name: skin }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData = this.formData.filter((item, index) => {
          return index !== idx
        })
      }
    },
    onSubmit() {
      const _data = this.tableData
      if (_data.length <= 0) {
        this.msgError('无可提交数据')
        return
      }
      for (const i in _data) {
        const val = _data[i]
        if (!val.type) {
          this.msgError('请选择活动类型')
          return
        }

        if (!val.name) {
          this.msgError('请输入活动名称')
          return
        }

        if (!val.value) {
          this.msgError('请输入文件夹名称')
          return
        }
      }

      const data = JSON.stringify(this.tableData)
      updateActiveSkinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getActiveSkinList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
